var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useState, useContext } from 'react';
import { Button } from '@one-thd/sui-atomic-components';
import { CodeFullDetailDescription, ConfirmValidMessage, ReturnError, ShowSpinner, Modal, ModalButtonGroup, } from '../commons';
import { modalBlurbs } from '../../../../../constants/NationalAccount';
import { NationalAccountContext } from '../../../../../contexts';
import { clickCta } from '../../../../../utils/analytics';
export var UnenrollModals = function () {
    var _a = useContext(NationalAccountContext), setIsLoading = _a.setIsLoading, setShowModal = _a.setShowModal, setErrorState = _a.setErrorState, currentAgreementCode = _a.currentAgreementCode, enrollAgreementCode = _a.enrollAgreementCode;
    var _b = useState(false), isFinalConfirm = _b[0], setFinalConfirm = _b[1];
    var handleUnenrollSubmit = function () { return __awaiter(void 0, void 0, void 0, function () {
        var response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setIsLoading(true);
                    return [4 /*yield*/, enrollAgreementCode(false, currentAgreementCode === null || currentAgreementCode === void 0 ? void 0 : currentAgreementCode.abbreviatedName, '')];
                case 1:
                    response = _a.sent();
                    setIsLoading(false);
                    if (response && !response.error) {
                        setShowModal(true);
                        setFinalConfirm(true);
                        clickCta('pricing benefits: national account incentives: unenrolled');
                    }
                    else {
                        setErrorState(true);
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    return (React.createElement(Modal, { title: modalBlurbs.unenroll.title.unenrollIncentives }, isFinalConfirm ? (React.createElement(FinalConfirmModal, null)) : (React.createElement(VerifyUnenrollModal, { handleUnenrollSubmit: handleUnenrollSubmit }))));
};
var FinalConfirmModal = function () {
    var setShowModal = useContext(NationalAccountContext).setShowModal;
    return (React.createElement("div", { className: "sui-flex sui-flex-col sui-justify-center sui-align-start", "data-testid": "FinalConfirmModal" },
        React.createElement("div", { className: "sui-flex sui-flex-col sui-justify-center sui-align-start sui-pb-4" },
            React.createElement(ConfirmValidMessage, { confirmMessage: modalBlurbs.unenroll.unenrollConfirmation, doJustifyStart: true }),
            React.createElement("p", { className: "sui-text-base" }, modalBlurbs.unenroll.unenrollConfirmationDisclaimer)),
        React.createElement("div", { className: "sui-flex sui-flex-row sui-justify-center sui-align-center" },
            React.createElement(Button, { variant: "primary", type: "submit", disabled: false, style: { width: '100%' }, onClick: function () {
                    setShowModal(false);
                    window.location.reload();
                } }, "Close"))));
};
var VerifyUnenrollModal = function (_a) {
    var handleUnenrollSubmit = _a.handleUnenrollSubmit;
    var _b = useContext(NationalAccountContext), setErrorState = _b.setErrorState, errorState = _b.errorState, setShowModal = _b.setShowModal, isLoading = _b.isLoading;
    var cancelModal = function () {
        setShowModal(false);
        setErrorState(false);
    };
    return (React.createElement("div", { className: "sui-flex sui-flex-col sui-justify-center sui-font-regular sui-text-1xl", "data-testid": "VerifyUnenrollModal" },
        React.createElement("p", { className: "sui-text-base sui-pt-4" }, modalBlurbs.unenroll.unenrollDoubleCheck),
        React.createElement("div", { className: "sui-pt-4" }, errorState ? React.createElement(ReturnError, null) : React.createElement(CodeFullDetailDescription, { isModal: true })),
        isLoading && React.createElement(ShowSpinner, null),
        React.createElement(ModalButtonGroup, { handleClose: cancelModal, confirmBlurb: modalBlurbs.unenroll.buttons.unEnrollConfirm, cancelBlurb: modalBlurbs.unenroll.buttons.unEnrollCancel, cb: handleUnenrollSubmit })));
};
